import Animation from "./Animation";
import {TimelineLite} from "gsap/all";
import Barba from "barba.js";

export default class Intro extends Animation {

    constructor() {
        super( false );

        this.setupElements()
        this.build()
    }

    setupElements() {
        this.container = document.querySelector('#intro-video');
        this.content = document.querySelector('.intro-content');
        this.ctas = document.querySelectorAll('.theme-ctas .theme-cta');
        this.header = document.querySelector('.intro-header');
    }

    clear() {
        this.timeline.clear(true);
        this.setupElements();
        this.build();
        return this
    }

    static key() {
        return 'intro'
    }

    onComplete() {
        document.querySelector('html').classList.remove('scroll-blocked')
    }

    build() {
        this.timeline.to( this.header, .35, { opacity: 1, y: 0 }, 'loading' )
            .addLabel('logo')
            .staggerTo( this.ctas, .4, { opacity: 1, y: 0, x: 0, rotate: -68 }, .1, 'logo')
            .to( this.container, .75, { css: { transform: "perspective(2000px) rotateX(0)" } }, "logo"  )
            .to( this.content.querySelector('.desktop .title'), .75, { css: { transform: "perspective(2000px) rotateY(0)" } }, "logo" )
            .addLabel('video')
            .to( this.content.querySelector('.desktop p'), .5, { opacity: 1, x: 0}, 'video' )
            .to( this.content.querySelector('.scroll-indicator'), .5, { opacity: 1, y: 0}, 'video' )
    }

}